module.exports = __webpack_public_path__ + "static/media/sandy07.e6ef8fed.png";